module.exports = __webpack_public_path__ + "static/media/DPIE.98da1ff8.png";